export const SCROLL_ACTIVATION_THRESHOLD = 1400;
export const TOP_SCROLL_THRESHOLD = 400;
export const BOTTOM_SCROLL_THRESHOLD = 5;